export default __webpack_public_path__ + "static/media/subjectsbackground.404834ad.svg";